// extracted by mini-css-extract-plugin
export default {"container":"ErrorMessage_container__eDobt","text":"ErrorMessage_text__wxNos"};